import { useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");

  useEffect(() => {
    // Release the reserved inventory so the piece is available again.
    if (sessionId) api.post(`/payments/cancel/${sessionId}`).catch(() => {});
  }, [sessionId]);

  return (
    <div className="mx-auto max-w-2xl px-4 py-24 text-center">
      <XCircle className="mx-auto h-12 w-12 text-kys-muted" />
      <h1 className="mt-6 font-serif text-3xl text-kys-ink">Checkout canceled</h1>
      <p className="mt-3 text-sm text-kys-charcoal">No payment was taken. Your bag is still saved.</p>
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/cart" className="rounded-full bg-kys-ink px-6 py-3 text-sm font-semibold text-white hover:bg-kys-accent">Return to bag</Link>
        <Link to="/shop" className="rounded-full border border-kys-ink px-6 py-3 text-sm font-semibold text-kys-ink hover:bg-kys-ink hover:text-white">Keep shopping</Link>
      </div>
    </div>
  );
}
